import React from 'react';
import './FloatingButtons.css';
import { FaPhoneAlt } from 'react-icons/fa';

function CallIcon() {
  return (
    <a
      href="tel:+917905513982"
      className="floating-button call"
      aria-label="Call Now"
    >
      <FaPhoneAlt className="call-icon" />
    </a>
  );
}

export default CallIcon;
